// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Feedback Trigger Styles */

.feedback-trigger {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999; /* Same as admin debug trigger */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.feedback-trigger-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.3);
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
  color: white;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.3);
  }
  50% {
    box-shadow: 0 4px 30px rgba(76, 175, 80, 0.5);
  }
}

.feedback-trigger-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 30px rgba(76, 175, 80, 0.5);
  animation: none;
}

.feedback-trigger-btn.active {
  background: linear-gradient(135deg, #388e3c, #1b5e20);
  box-shadow: 0 4px 20px rgba(56, 142, 60, 0.3);
  animation: none;
}

.feedback-trigger-btn.active:hover {
  box-shadow: 0 6px 30px rgba(56, 142, 60, 0.5);
}

.feedback-trigger-tooltip {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  border: 1px solid #333;
  backdrop-filter: blur(4px);
}

.feedback-trigger-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 20px;
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

.feedback-trigger:hover .feedback-trigger-tooltip {
  opacity: 1;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .feedback-trigger {
    bottom: 15px;
    right: 15px;
  }
  
  .feedback-trigger-btn {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FeedbackTrigger.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa,EAAE,gCAAgC;EAC/C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Feedback Trigger Styles */\n\n.feedback-trigger {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999; /* Same as admin debug trigger */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.feedback-trigger-btn {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.3);\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);\n  color: white;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(76, 175, 80, 0.5);\n  }\n}\n\n.feedback-trigger-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 30px rgba(76, 175, 80, 0.5);\n  animation: none;\n}\n\n.feedback-trigger-btn.active {\n  background: linear-gradient(135deg, #388e3c, #1b5e20);\n  box-shadow: 0 4px 20px rgba(56, 142, 60, 0.3);\n  animation: none;\n}\n\n.feedback-trigger-btn.active:hover {\n  box-shadow: 0 6px 30px rgba(56, 142, 60, 0.5);\n}\n\n.feedback-trigger-tooltip {\n  position: absolute;\n  bottom: 70px;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  border: 1px solid #333;\n  backdrop-filter: blur(4px);\n}\n\n.feedback-trigger-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  right: 20px;\n  border: 5px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.feedback-trigger:hover .feedback-trigger-tooltip {\n  opacity: 1;\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .feedback-trigger {\n    bottom: 15px;\n    right: 15px;\n  }\n  \n  .feedback-trigger-btn {\n    width: 50px;\n    height: 50px;\n    font-size: 20px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
